module.exports = __webpack_public_path__ + "static/media/sidebar.89510e37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar.jpg
// module id = 1036
// module chunks = 0